import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import legend from '../../images/about/lazerUygulamalari.jpg';
import kilcal from '../../images/kozmetik/16001710716615.jpg';
import lazer from '../../images/kozmetik/1600170895478.jpg';
import leke from '../../images/kozmetik/16001713555310.jpg';
import yenileme from '../../images/kozmetik/1600171539267.jpg';

import '../../styles/subItem.css'

const LekeTedavisi = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='sub-page'>
            <Image src={legend} fluid className="subItemPage-img" />
            <Container>
                {/* First Row */}
                <Row className="mt-4">
                    <Col>
                        <h2>LAZERLE LEKE TEDAVİSİ</h2>
                        <hr />
                        <div className='image-frame'>
                            <Image src={leke} className='subitem-img' />
                        </div>
                        <p>Leke tedavisi’de cildimizde bazı etkenlerden meydana gelen lekelerin, bir kısmı ise güneşin cildimize verdiği hasarlar, yara izleri, hormonal pigmentasyon ve diğer deformasyon için ClearLift, Kimyasel Peelingi, Clear Brilliant etkili leke tedavileri sunar. Lazerle leke tedavileride cilde gönderilen lazer ışığı sadece sorunlu bölge üzerinde çalışarak etrafındaki dokulara zarar vermeden lekelerin tedavi etmesini sağlıyor. Üstelik bu tedavi yöntemi kolajen üretimini uyarır.</p>
                        <p>Lazerle leke tedavisi güneş lekesi, çiller, yaşlılık lekeleri, et benleri ve doğum lekelerinde tek başına veya diğer yöntemlerle beraber kullanılabilir.</p>
                        <p>Lazerle leke tedavisinde seans sayısı lekenin cinsi, derinliği ve kişinin cilt yapısı ile alakalıdır. Yüzeysel bir çil tek seansta gerilerken derin bir çil 4-5 seans gerektirebilir. Doğum lekeleri 10-15 seans sürebilir. Melazma tarzındaki güneş lekeleri 8-10 uygulama gerektirebilir. Leke tedavilerinde seans aralıkları ortalama 3-8 hafta olabilir.</p>
                    </Col>
                    <hr />
                </Row>
                {/* Second Row */}
                <Row className='justify-content-md-start mt-3'>
                    <h2 className='mb-4'>Lazer Uygulamaları</h2>
                    <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/lazer-epilasyon" onClick={handleScrollToTop} >
                                <Card.Body>
                                    <p>LAZER EPİLASYON</p>
                                    <div className='card-image-frame'>
                                        <Image src={lazer} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/kilcal-damar-ve-varis-tedavisi" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>LAZERLE KILCAL DAMAR VE VARİS TEDAVİSİ</p>
                                    <div className='card-image-frame'>
                                        <Image src={kilcal} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                      
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/lazer-uygulamalari/cilt-yenileme" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>LAZERLE CİLT YENİLEME</p>
                                    <div className='card-image-frame'>
                                        <Image src={yenileme} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>


                </Row>
            </Container>
        </div>
    )
}

export default LekeTedavisi